import React, { useEffect, useState } from 'react'
import { AddRounded, CloseRounded, DeleteRounded, DoNotDisturbAltRounded, EditRounded } from '@mui/icons-material';
import moment from 'moment'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { actionDeletePost, actionFetchPosts } from '../../../actions/posts';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import {Button, Loader} from '../../';
import { PostsListHeader } from '../../../utils/constants';
import { posts, users } from '../../../assets';
import { StatePostParams } from '../../../types/posts/postParams';

import './postTable.css'

const PostTable = () => {
  const dispatch                  = useDispatch<AppDispatch>();
  const {isLoading, getAllPosts}  = useSelector((state: RootState) => state?.postList);
  const [allPosts, setAllPosts]   = useState<StatePostParams[]>(getAllPosts);
  const [isOpen, setIsOpen]       = useState<{ [key: number]: boolean }>({})
  const [page, setPage]           = useState<number>(1);

  const handleClick = (index: number) => () => {
    setIsOpen(prev => ({ [index]: !prev[index]}))
  }

  interface DeletePostParams {
    detailId: string;
    title: string;
  }

  const handleDeletePost = ({detailId, title}: DeletePostParams) => {
    if (window.confirm(`Are you sure you want to delete this post ${title}?`)) {
      // Dispatch the deletePost action here
      dispatch(actionDeletePost({id: detailId}))
        .then(() => {
          setAllPosts(allPosts.filter(post => post._id !== detailId));
          // Show success toast after successfully deleting the post
          toast.success('post deleted successfully');
        })
        .catch((error) => {
          // Handle any errors that occur during the deletion process
          toast.error('Error deleting post: ' + error.message);
        });
    }
  };
  
  useEffect(() => {
    dispatch(actionFetchPosts({page})); // You can pass the page number as needed
  }, [dispatch, page]);
  
  //isLoading, data, currentPage and numberOfPages
  if(!allPosts?.length && !isLoading) return (
    <>
      <div className='empty-profile-card-wrapper'>
        <div className='empty-profile-card-header'>
          <span><DoNotDisturbAltRounded /></span>
          <h1> No Post Found </h1>
        </div>
        <Link className='view-posts' to="/posts/create-post">create post</Link>
      </div>
    </>
  )

  return (
    <>
      <div className='table-main-wrapper'>
        <div className='table-header'>
          <h3>Posts</h3>
          <Button buttonWrapper="button-wrapper" linkButton linkTo="posts/view-posts" linkClass="link-wrapper" linkName="View all" />
        </div>
        {isLoading ? <Loader /> : (
          <table className='main-table'>
            <thead>
              <tr>
                {PostsListHeader.map((option, index) => (
                  <th key={index}>{option.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allPosts.map((detail, index) => {
              return(
                <tr key={index}>
                  <td data-cell="image">
                    <div className="table-image">
                      {isLoading ? <Loader /> : (
                        <img src={detail.selectedFile ? detail.selectedFile : posts} alt="img" />
                      )}
                    </div>
                  </td>
                  <td data-cell="title">{detail.title}</td>
                  <td data-cell="category">{detail.category}</td>
                  <td data-cell="link">{detail.link}</td>
                  <td data-cell="created">{moment(detail.createdAt).format('YYYY-MM-DD')}</td>
                  <td data-cell="edit">
                    <div  className={isOpen[index] ? 'button-option active' : 'button-option'}>
                      <button className='button-option-head' onClick={handleClick(index)}>{isOpen[index] ? (<span><CloseRounded /></span>) : (<span><AddRounded /></span>)}</button>
                      <div className='button-menu-option'>
                        <Link to={`/posts/edit-post/${detail._id}`} className='button-menu-detail'>
                          <EditRounded />
                          <span>Edit post</span>
                        </Link>
                        <button className='button-menu-detail' onClick={() => handleDeletePost({ detailId: detail._id, title: detail.title }) }>
                          <DeleteRounded />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )})}
            </tbody>
          </table>
        )}
      </div>
    </>
  )
}

export default PostTable